import MediaFileType from '@/shared/constants/MediaFileType';
import MediaTargetType from '@/shared/constants/MediaTargetType';
import { BASE_SCHEMA } from '@/shared/converters/baseConverters';
import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { Url } from '@/shared/models/common';
import { isImage } from '@/shared/utils/image';
import { isPresent } from '@/shared/utils/typescript';
import InvoiceFile from '../models/InvoiceFile';
import MediaFile from '../models/MediaFile';
import MediaTarget from '../models/MediaTarget';

const SCHEMA = {
  ...BASE_SCHEMA,
  contentId: 'mediaFileId',
  type: 'type',
  isLocked: 'isLocked',
  content: 'content',
  medium: 'contentResized.medium_content',
  thumbnail: parseThumbnail,
  target: 'externalEntityType',
  description: 'description',
  note: 'note',
};

const INVOICE_SCHEMA = {
  ...SCHEMA,
  reference: 'metaData1',
};

// TODO use in more places
export function parseMediaFile(data: any): MediaFile | null {
  return parseEntity(data, SCHEMA, MediaFile);
}

export function parseMediaTarget(data: any): MediaTarget {
  switch (data.entityOrigin) {
    case 'job':
      return { type: MediaTargetType.JOB, id: data.entityId };
    case 'diagnosticStep':
      return { type: MediaTargetType.DIAGNOSTIC, id: data.entityId };
    case 'dossierAttachment':
      return { type: MediaTargetType.DOSSIER, id: data.entityId };
    default:
      throw new Error(`unknown entityOrigin: ${data.entityOrigin}`);
  }
}

export function parseMediaFiles(data: any, target?: MediaTargetType): Array<MediaFile> {
  const mediaFiles = parseEntities(data, SCHEMA, MediaFile);
  if (isPresent(target)) mediaFiles.forEach((m => m.target = target));
  return mediaFiles;
}

export function parseThumbnail(data: any): Url | null {
  const url = data.thumbnail || data.contentResized?.extrasmall_content || data.contentResized?.small_content || data.contentResized?.medium_content;
  if (data.type === MediaFileType.PDF && isImage(url)) return url;
  if (data.type === MediaFileType.IMAGE) return url || data.content || null;
  return url || null;
}

export function parseInvoiceFile(data: any): InvoiceFile | null {
  return parseEntity(data, INVOICE_SCHEMA, InvoiceFile);
}

export function parseInvoiceFiles(data: any): Array<InvoiceFile> {
  return parseEntities(data, INVOICE_SCHEMA, InvoiceFile);
}
